import _ from "lodash"
import { SubscriptionCardStyle3 } from "./subscription-card-style3"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { selectprogramsListItems } from "../../../redux/programs/selector";
import { useAppDispatch } from "../../../hooks/hooks";
import { programs } from "../../../redux/programs/action";

export const DBaasSubscription = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const [dbaasProgram, setDBaasProgram] = useState<any>([]);
  const itemsData = useSelector(selectprogramsListItems)
 
    useEffect(() => {
      dispatch(programs.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,entity:'programs',jsonData:{
         }})).then(()=>{
    })}, [])
    useEffect(() => {
      setDBaasProgram(itemsData?.result?.items);
  }, [itemsData]);

  const subscribe = (item: any) => {
    navigate(`${item?.Id}`)
  }
  return (
    <>
      <div className="bg-[#f0f4f8] px-4 py-16 min-h-screen">
        <div aria-hidden="true" className="absolute inset-0 h-max w-full m-auto grid grid-cols-2 -space-x-52 opacity-20">
          <div className="blur-[106px] h-56 bg-gradient-to-br to-purple-200 from-blue-200"></div>
          <div className="blur-[106px] h-32 bg-gradient-to-r from-cyan-200 to-indigo-200"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 xl:px-6">
          <div className="mb-10 space-y-4 px-6 md:px-0">
            <h2 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl md:text-4xl">Subscriptions</h2>

          </div>
          <div className="grid xl:grid-cols-3 sm:grid-cols-4 grid-cols-2 gap-8 mb-[46px]">
            {dbaasProgram && _.map(dbaasProgram, (item: any) => (
              <SubscriptionCardStyle3 subscription={item} subscribe={subscribe} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}